import { Component, OnInit } from '@angular/core';
import { ProductStockLevel } from '../../models/product-stock-level.model';

/**
 * One label per line of the stock movement just posted (goods-in, goods-out, adjustment or
 * transfer) - each page hands its result over via router state rather than this component
 * fetching anything itself, since the movement response already carries the product and
 * location each line resolved to.
 *
 * The QR on each label still points at the product (`scanType='product'`), matching every other
 * product label in the app, but the visible text leads with the location - that is what an
 * operator standing at a shelf needs to read, the scan is for the system to identify what is on
 * it.
 */
@Component({
    selector: 'app-stock-movement-labels',
    templateUrl: './stock-movement-labels.component.html',
    styleUrls: ['./stock-movement-labels.component.scss'],
    standalone: false
})
export class StockMovementLabelsComponent implements OnInit {

  levels: ProductStockLevel[] = [];

  ngOnInit(): void {
    // Read after the fact rather than via Router.getCurrentNavigation(), which is only valid
    // while the navigation triggering this component is still in flight - reading window.history
    // directly works regardless of how this component ended up on screen, including a refresh,
    // which then correctly shows nothing to print rather than throwing.
    const state: any = window.history.state;

    this.levels = state && state.levels ? state.levels : [];
  }

  /** Warehouse name folded in alongside the shelf, since a label has room for one prominent line, not two. */
  getShelf(level: ProductStockLevel): string {
    if (!level.warehouseLocation) {
      return '';
    }

    const warehouseName = level.warehouseLocation.warehouse ? level.warehouseLocation.warehouse.name : '';
    const shelf = level.warehouseLocation.aisle + ' / ' + level.warehouseLocation.shelf;

    return warehouseName ? warehouseName + ' · ' + shelf : shelf;
  }

  getProductName(level: ProductStockLevel): string {
    return level.product ? level.product.name : '';
  }

  getSku(level: ProductStockLevel): string {
    return level.product && level.product.sku ? 'SKU: ' + level.product.sku : '';
  }

  print(): void {
    window.print();
  }

  continueToStockLevels(): void {
    window.location.href = '/warehousing/stock-levels';
  }
}
